import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getTypesensePublishes } from "./actions";

export const typesensePublishesEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
});

const initialState = typesensePublishesEntityAdapter.getInitialState({
  facets: {},
  totalCount: 0,
});

export const typesensePublishesSlice = createSlice({
  name: "typesensePublishes",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getTypesensePublishes.fulfilled, (state, action) => {
      if (!action.payload.error) {
        const data = action.payload.data;

        typesensePublishesEntityAdapter.setAll(state, data.results);
        state.facets = data.facets;
        state.totalCount = data.total;
      }
    });
  },
});

export default typesensePublishesSlice.reducer;
